import ru from '@/assets/locale/ru.json';
import kk from '@/assets/locale/kk.json';
import en from '@/assets/locale/en.json';

export const defaultLocale = 'kk';
export const languages = {ru, kk, en}
